export const ADD_NEW_C_TARGETING_REQUEST = "ADD_NEW_C_TARGETING_REQUEST"
export const ADD_NEW_C_TARGETING_FAILED = "ADD_NEW_C_TARGETING_FAILED"
export const ADD_NEW_C_TARGETING_SUCCESS = "ADD_NEW_C_TARGETING_SUCCESS"


export const GET_C_TARGETING_LIST_REQUEST = 'GET_C_TARGETING_LIST_REQUEST'
export const GET_C_TARGETING_LIST_SUCCESS = 'GET_C_TARGETING_LIST_SUCCESS'
export const GET_C_TARGETING_LIST_FAILED = 'GET_C_TARGETING_LIST_FAILED'


export const GET_C_TARGETING_SEGMENTS_REQUEST = 'GET_C_TARGETING_SEGMENTS_REQUEST'
export const GET_C_TARGETING_SEGMENTS_SUCCESS = 'GET_C_TARGETING_SEGMENTS_SUCCESS'
export const GET_C_TARGETING_SEGMENTS_FAILED = 'GET_C_TARGETING_SEGMENTS_FAILED'


  
export const AddCTargetingAction = (value: any) => {
  // let valuesArr: any[] = [];
  // for (const key in value) {
  //   if (key.includes("value")) {
  //     if (value[key]) {
  //       valuesArr.push(value[key]);
  //     }
  //   }
  // }
  // // value.values=valuesArr;

  // if(value.type==="IP Address"){
  //     value.type ="IP_Address"
  //   }else if(value.type==="WEB_ID"){
  //     value.type ="BEESWAX"
  // }
  
  // let data = {
  //   campaign:value.campaign,
  //   isCsv:value.isCsv,
  //   type: value.type,
  //   values: valuesArr,
  // };
  // console.log(value);
  return { type: ADD_NEW_C_TARGETING_REQUEST, payload: value };
};

export const GetCTargetingListAction = (filtersObjects: any) => {
  return {
      type: GET_C_TARGETING_LIST_REQUEST,
      filtering: filtersObjects
  }
}


export const GetCTargetingSegmentsAction = () => {
  return {
      type: GET_C_TARGETING_SEGMENTS_REQUEST
  }
}